module.exports = __webpack_public_path__ + "static/mossoro-logo-1cbce6c111602801f1bb3c5dbea9bf5a.jpg";